import Prefixes from './arrays/prefixes'
import Countries from './arrays/countries'
import Locations from './arrays/locations'
import Sexes from './arrays/sexes'
import YesNo from './arrays/yesno'
import Length from './arrays/length'
import Displacement from './arrays/displacement'
import Towings from './arrays/towings'

export default {
  yesno: YesNo,
  prefixes: Prefixes,
  countries: Countries,
  locations: Locations,
  sexes: Sexes,
  length: Length,
  displacement: Displacement,
  towings: Towings,
  title: 'Español',
  home: {
    title: "Nos unen las distancias",
    subtitle: "DANDO SERVICIO DESDE 1977",
  },
  header: {
    routesandschedules: "rutas y horarios",
    travelbyferry: "viajar en ferry",
    customersupport: "atención al cliente",
    aboutromeu: "sobre romeu ferries",
    locatereservation: "Localiza tu reserva",
    ferrysalicante: "Ferries desde Alicante",
    ferrysbarcelona: "Ferries desde Barcelona",
    ferrysoran: "Ferries a Orán",
    ferrysmostaganem: "Ferries a Mostaganen",
    ferrysargel: "Ferries a Argel",
  },

  cities: {
    ferrysa: "Ferries desde",
    ferrysb: "Ferries a",
    alicante: "ALICANTE",
    barcelona: "BARCELONA",
    oran: "ORÁN",
    argel: "ARGEL",
    mostaganem: "MOSTAGANEM",
  },

  headernav: {
    yourselection: "TU SELECCIÓN",
    yourdata: "TUS DATOS",
    summary: "RESUMEN Y PAGO",
    confirmation: "CONFIRMACIÓN RESERVA",
  },

  information: {
    attentiontitle: "Atención",
    attentionsubtitle: "AL CLIENTE",
    attentiontext: "",

    routestitle: "Ferries",
    routessubtitle: "RUTAS Y HORARIOS",
    routestext: "",

    abouttitle: "Todo sobre",
    aboutsubtitle: "ROMEU FERRIES",
    abouttext: "Romeu y Compañía es una empresa de origen familiar fundada en Tarragona a mediados del siglo XIX, y que se consolidó a partir del año 1939, cuando los hermanos Ernesto y Manuel Romeu Escandell asumieron su dirección. Dentro del área de consignación de buques ha expandido su red de oficinas, primero por todos los principales puertos españoles y posteriormente en el Norte de África y en América.",
    formtitle: "FORMULARIO DE CONTACTO",
    knowmorre: "SABER MÁS",
  },

  locatereserve: {
    title: "Localiza tu reserva",
    description: "Introduzca su código de reserva para descargar el comprobante de la misma.",
    reserve: "Código de reserva",
    error: "Código de reserva no encontrada",
    buttonsearch: "Localizar",
    message: "Atención, recuerde que con el reserva debe obtener la tarjeta de embarque en la terminal.",
    condition: "Por favor, consulte nuestras condiciones de servicio.",
    buttonprint: "imprimir reserva",
    buttondownload: "descargar reserva",
  },

  fastbooking: {
    calendar: {
      daysshort: ["LUN", "MAR", "MIE", "JUE", "VIE", "SAB", "DOM"],
      daysname: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
      monthnames: ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
          "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"],

      monthshort: ["ENE.", "FEB.", "MAR.", "ABR.", "MAY.", "JUN.",
          "JUL.", "AGO.", "SEP.", "OCT.", "NOV.", "DIC."],
    },
    travels:{
      roundtrip: "IDA Y VUELTA",
      onlygoing: "SOLO IDA",
    },
    tabs: {
      going: "ida",
      return: "vuelta",
      roundtrip: "ida y vuelta",
      passengers: "pasajero/s",
      vehicles: "vehículo/s",
      find: "buscar",
    },
    origin: {
      origin: 'ORIGEN',
      destiny: 'DESTINO',
      confirmrute: 'CONFIRMA LA RUTA',
    },
    passengers: {
      adults: "ADULTO/S",
      adultsdetails: "Mayores de 26 años",
      teens: "JÓVEN/ES",
      teensdetails: "De 12 a 26 años",
      kids: "NIÑO/S",
      kidsdetails: "De 3 a 12 años",
      babys: "BEBÉ/S",
      babysdetails: "Menores de 3 años",
      pets: "PERRO/S",
      petsdetails: "Solo perros",
      family: "Familia numerosa",
      couple: "Parejas que viajan juntas",
      confirm: "CONFIRMAR PASAJEROS",
    },
    vehicles: {
      cars: "TURISMO/S",
      carsdetails: "Vehículo de hasta 5 plazas",
      vans: "FURGONETA/S",
      vansdetails: "Furgonetas y autocaravanas",
      motorcycles: "MOTO/S",
      motorcyclesdetails: "Motocicletas, Motos, ...",
      bikes: "BICICLETA/S",
      bikesdetails: "Vehículo sin motor",
      towings: "REMOLQUE/S",
      towingsdetail: "Remolques y caravanas",
      confirmvehicles: "CONFIRMA VEHÍCULOS",
      confirmnovehicles: "VIAJO SÍN VEHÍCULO",
    },
    departure: {
      selectdate: "SELECCIONA FECHA DE IDA",
      confirm: "CONFIRMA IDA",
      find: "BUSCAR FERRY",
    },
    return: {
      selectdate: "SELECCIONA FECHA DE IDA",
      find: "BUSCAR FERRY",
    }
  },

  lastFooter : {
    content: "Romeu y Cía., todos los derechos reservados. Avinguda Diagonal 403, 4ª planta · Teléfono: +34 93 292 21 21 · Fax: +34 93 415 07 07 · Email: <a class=\"white-link\" href=\"mailto:pasajes@romeuycia.com\">pasajes@romeuycia.com</a>",
  },

  footer : {
    legal: "Aviso legal",
    conditions: "Condiciones del servicio",
    privacitat: "Política de Privacidad",
    cookies: "Política de Cookies",
  },

  faqs : {
    title: "Viajar en Ferries",
    plazasTit: "Acomodación",
    plazasP: "Los ferries disponen de las siguientes acomodaciones :",
    plazasText: ["- Butaca turista","- Literas : Habitación de 4 camas (a compartir) con lavabo.","- Camarote, interior o exterior, de 2 o 4 camas (a compartir). Disponen de baño completo y aire acondicionado. Cena y desayuno incluidos."],
    reservaTit: "Realización de la reserva",
    reservaText: "Una vez efectuada la reserva on-line , el sistema asignará un número de reserva provisional. Una vez confirmemos disponibilidad de plazas, en menos de 24 horas hábiles le enviaremos a la dirección de correo electrónico indicada, un e-mail con el billete que deberá imprimir y presentar en ventanilla el día de viaje para obtener la correspondiente tarjeta de embarque",
    documentacionTit: "Documentación para viajar",
    documentacionText: ["- Pasajeros : Pasaporte en regla y con visado si se precisa.","- Vehículos : Documentación original del mismo.","- Vehículos exportación : Documentación del vehículo y documentos de exportación.","- Mascotas : Cartilla de vacunación en regla."],
    targetaTit: "Tarjetas de embarque",
    targetaText: "Presentación en ventanilla 3 horas antes de la salida, con el billete, pasaporte de todos los pasajeros y documentación del vehículo. ",
    pasajeros: "Pasajeros",
    any: "- Para las tarifas de IDA o IDA/VUELTA 1 año hay 5 rango de edades:",
    anylist: ["- Bebés: 0 a 2 años (p ej, 2 años y 11 meses es bebé)","- Niño: 3 a 11 años","- Joven:12 a 25 años","- Adulto:26 a 54 años","- Senior: A partir de los 55  años."],
    sesenta: "- Tarifas promocionales IDA/VUELTA 60 días hay solo 3 rango de edades:",
    sesentalist: ["- Bebés: 0 a 2 años","- Niño: 3 a 11 años","- Adulto: A partir de los 12 años."],
    seis: "- Tarifa 6 meses no hay distinción de edad salvo que sea un bebé (0 a 2 años) que siempre es gratuito.",
  },
  Secctiontext : {
    title: "Sobre Romeu Ferries",
    tuno: "Historia",
    puno: "Romeu y Compañía es una empresa de origen familiar fundada en Tarragona a mediados del siglo XIX, y que se consolidó a partir del año 1939, cuando los hermanos Ernesto y Manuel Romeu Escandell asumieron su dirección. Dentro del área de consignación de buques ha expandido su red de oficinas, primero por todos los principales puertos españoles y posteriormente en el Norte de África y en América. Además del área de pasajeros también realiza la consignación de  buques de mercancías representando a Navieras que viajan  a múltiples destinos por todo el mundo. Para más información consulte nuestra web ",
    tdos: "¿Quienes somos?",
    pdos: "Romeu Ferries es una división de la empresa Romeu y cia S.A., perteneciente al Grupo Romeu, destacado Holding logístico español con una larga trayectoria en el sector del transporte marítimo. En 1977 Romeu comenzó su colaboración con  la compañía estatal argelina de ferrys  ENTMV en el puerto de Alicante, siendo desde entonces su agente de manera ininterrumpida en dicho puerto y colaborando en el crecimiento y consolidación del servicio, convirtiéndose en un referente para  la ciudad de Alicante, en donde cada año, principalmente durante la campaña de verano, miles de personas con sus respectivos vehículos realizan la ruta entre Alicante y los principales puertos argelinos en los barcos de la compañía ENTMV.  En 2017 se ha añadido una nueva ruta complementaria desde Barcelona a Argelia, con la intención de seguir creciendo y ofrecer más alternativas para sus desplazamientos a los pasajeros de la línea.",
    ttres: "¿Que hacemos?",
    ptres: "Durante la segunda mitad del siglo XX  tras el crecimiento de la actividad consignataria se comenzaron a desarrollar otras actividades dentro del mundo del transporte, tales como almacenaje, agencias de Aduanas, consolidadores, transitarias, y otras, que han llevado al Grupo Romeu a ser reconocido como el principal Holding español de logística internacional de mercancías, expandiendo su actividad con delegaciones en Europa, África, América y Asia, y continuando su accionariado íntegramente en manos de la familia Romeu. Para más información consulte nuestra web ",
  },
  noAvailableFerriesText: "Lo sentimos, no hay Ferries disponibles.",
  table : {
    alicante: {
      title: "Ferries desde Alicante",
      text: "Durante los meses de verano, salidas/llegadas diarias con origen/destino Orán. Resto del año, salidas/llegadas semanales con origen/destino Orán. También salidas/llegadas esporádicas con origen/destino Argel y Mostaganem",
      departure: "Salida",
      departureArrival: "Hora salida / llegada",
      duration: "Duración",
      destination: "Destino",
      origin: "Origen",
      vessel: "Buque"
    },
    barcelona: {
      title: "Ferries desde Barcelona",
      text: "Durante los meses de verano, salidas/llegadas semanales con origen/destino Mostaganem. Resto del año, salidas/llegadas quincenales con origen/destino Mostaganem.  También salidas/llegadas esporádicas con origen/destino Argel y Orán",
      departure: "Salida",
      departureArrival: "Hora salida / llegada",
      duration: "Duración",
      destination: "Destino",
      origin: "Origen",
      vessel: "Buque"
    },
    mostaganem: {
      title: "Ferries a Mostaganem",
      text: "Durante los meses de verano, salidas/llegadas semanales con origen/destino Barcelona. Resto del año, salidas/llegadas quincenales con destino Barcelona. También salidas/llegadas esporádicas con origen/destino Alicante",
      departure: "Salida",
      departureArrival: "Hora salida / llegada",
      duration: "Duración",
      destination: "Destino",
      origin: "Origen",
      vessel: "Buque"
    },
    argel: {
      title: "Ferries a Argel",
      text: "Salidas/llegadas ocasionales con origen/destino Alicante y Barcelona",
      departure: "Salida",
      departureArrival: "Hora salida / llegada",
      duration: "Duración",
      destination: "Destino",
      origin: "Origen",
      vessel: "Buque"
    },
    oran: {
      title: "Ferries a Orán",
      text: "Durante los meses de verano, salidas/llegadas diarias con origen/destino Alicante. Resto del año, salidas/llegadas semanales con origen/destino Alicante. También salidas/llegadas esporádicas con origen/destino Barcelona",
      departure: "Salida",
      departureArrival: "Hora salida / llegada",
      duration: "Duración",
      destination: "Destino",
      origin: "Origen",
      vessel: "Buque"
    },

  },

  search: {
    promotitle: "¡Promociones de ida y vuelta disponibles!",
    promos: {
      '60days': "Vuelta antes de 60 días",
      '6months-al': "Vuelta antes de 6 meses",
      '6months-ba': "Vuelta antes de 6 meses",
    },
    promomessage: "Las promociones solo son válidas para un máximo de 5 pasajeros",
    going: "Ida",
    return: "Vuelta",
    confirm: "CONTINÚA CON TU RESERVA",
    travel: {
      departure: "Salida",
      arrival: "Llegada",
      duration: "Duración",
      boatname: "Nombre barco",
      Reservation: "Reserva",
    },
  },

  dataresume: {
    contacttitle: "Datos de contacto",
    contacttext: "Todos los campos son obligatorios. La dirección de e-mail y el móvil se utilizarán para informarte de cualquier novedad que se produzca en tu viaje, así como para enviarte un e-mail recordatorio de tu reserva",
    contactequal: "Los datos del pasajero coinciden con los datos del contacto",
    passengerstitle: "Datos de pasajeros",
    vehicletitle: "Datos de vehículos",
    confirm: "CONFIRMAR DATOS",
    previous: "VOLVER ATRÁS",
    passenger: "Pasajero",
    vehicle: "Vehículo",
    adult: "ADULTO",
    teen: "JÓVEN/ES",
    kid: "NIÑO",
    baby: "BEBÉ",
    car: "TURISMO",
    van: "FURGONETA",
    motorcycle: "MOTO",
    towing: "REMOLQUE",
    names: {
      name: 'Nombre',
      surname: 'Primer apellido',
      namesurname: "Nombre y apellidos",
      secondSurname: 'Segundo apellido (Opcional)',
      numberDocument: 'Nº de Pasaporte',
      prefix: 'Prefijo',
      phone: 'Teléfono móvil',
      email: 'Email',
      repeatEmail: 'Repetir email',
      postalcode: 'C.P.',
      locationGone: 'Ubicación Ida',
      locationReturn: 'Ubicación Vuelta',
      nationality: 'Nacionalidad',
      birthDate: 'Fecha Nac.',
      birthDate2: 'Fecha Nacimiento',
      gender: 'Género',
      brand: 'Marca',
      model: 'Modelo',
      licensePlate: 'Matrícula',
      exported: 'Vehículo de exportación',
      length: 'Longitud (m)',
      displacement: 'Cilindrada',
      towing: 'Remolque',
    },
    errors: {
      heisrequired: "El XXX es requerido",
      sheisrequired: "La XXX es requerida",
      incorrectformat: "El mail tiene un formato incorrecto",
      incorrectformatdate: "El formato es incorrecto",
      duplicatemail: "El email repetido no coincide con el email introducido",
    },
  },

  resume: {
    infotext: "A continuación te presentamos el resumen el detalle de tu reserva para que puedas confirmarla y finalizar la compra online. Una vez que hagas click en el botón de confirmación, procederás a realizar el pago en la pasarela de pago de nuestra entidad bancaria, retornando a nuestro sitio web cuando el proceso haya finalizado.",
    passengersinfo: "Datos de los pasajeros",
    editdetails: "EDITAR DATOS",
    vehiclesinfo: "Datos de los vehículos",
    confirm: "CONFIRMAR DATOS Y PAGO",
    breakdown: {
      title: "Desglose de la reserva",
      tripgoing: "Viaje de ida",
      tripreturn: "Viaje de vuelta",
      departuredate: "Fecha de salida",
      departuretime: "Hora de salida",
      reservation: "Reserva",
      vehicles: "Vehículos",
      totalgoing: "Total ida",
      totalreturn: "Total vuelta",
      totalreservation:"Total reserva",
      adult: "Pasajero adulto (Mayores de 26 años)",
      teen: "Pasajero joven (De 12 a 26 años)",
      kid: "Pasajero niño (De 3 a 12 años)",
      baby: "Bebé (Menores de 3 años)",
      pet: "Perro",
      car: "Turismo",
      van: "Furgoneta / Autocaravana",
      motorcycle: "Moto",
      towing: "Remolque / Caravana",
      bike: "Bicicleta",
    },
    contactinformation: {
      title: "Datos de Contacto",
      namesurname: "Nombre y apellidos",
      passport: "Nº de Pasaporte",
      phone: "Teléfono",
      email: "Email",
      postalCode: "Código postal",
    },
  },

  confirmation: {
    info: "Su reserva ha sido realizada, a continuación podrá descargar e imprimir su reserva. Además le hemos enviado a la dirección de email de contacto todos los datos. Gracias por utilizar nuestros servicios online.",
    reservation: "Número de reserva",
    message: "Atención, recuerde que con el reserva debe obtener la tarjeta de embarque en la terminal.",
    condition: "Por favor, consulte nuestras condiciones de servicio.",
    buttonprint: "imprimir reserva",
    buttondownload: "descargar reserva",
    errorTitle: "Error al realizar el pago, póngase en contacto con nosotros.",
    errormessange: "Telefono de contacto: +34 965 147 010",
  },

  legal: {
    notices: {
      warning: {
        title: "Aviso legal",
        content: `
          <p>
            ROMEU Y CIA. S.A., en cumplimiento de la normativa vigente en materia de protección de datos de carácter personal
            (Ley Orgánica 15/1999, de 13 de diciembre de Protección de Datos de Carácter Personal) , así como la regulación
            existente en materia de servicios de la sociedad de la información y comercio electrónico (Ley 34/2002, de 11 de
              julio de servicios de la sociedad de la información y correo electrónico) pone en su conocimiento las presentes
              condiciones generales de uso que se aplican a todas las operaciones realizadas a través de la web:
              www.romeuycia.com
          </p>
          <p>
            De conformidad con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio
            electrónico” en vigor desde julio de 2002, comunicamos que este sitio web pertenece a:
          </p>
          <p>
            <div>Nombre fiscal de la sociedad: ROMEU Y CIA. S.A.</div>
            <div>CIF de la sociedad: A-28402006</div>
            <div>Domicilio de la sociedad: C/ Jorge Juan, 6, 03002, Alicante</div>
            <div>Teléfono: +34 93 292 21 25.Fax: +34 93 415 07 07</div>
            <div>Correo electrónico: barcelona@romeuycia.com</div>
            <div>Datos legales y/o registrales de la sociedad: Inscrita en el Registro Mercantil de Madrid,
              Tomo 3,757, Folio 19, Hoja 28,718. Inscripción 1.ª</div>
          </p>
          <h3>Condiciones de uso</h3>
          <h4>1. Propiedad intelectual de la web</h4>
          <p>
            Todos los derechos de propiedad intelectual del contenido de esta página web, su diseño gráfico y sus códigos fuente,
            son titularidad exclusiva de ROMEU Y CIA. S.A. a quien le corresponde el ejercicio exclusivo de los derechos de
            explotación de los mismos. Por tanto queda prohibida su reproducción, distribución, comunicación pública y
            transformación, total o parcial, sin la autorización expresa de ROMEU Y CIA. S.A. Igualmente, todos los nombres
            comerciales, marcas o signos distintos de cualquier clase contenidos en este web site están protegidos por ley.
          </p>
          <h4>2. Contenido de la web y enlaces</h4>
          <p>
            ROMEU Y CIA. S.A., no se responsabiliza del mal uso que se realice de los contenidos de su página web, siendo
            exclusiva responsabilidad de la persona que accede a ellos o los utiliza. Tampoco asumimos ninguna responsabilidad
            por la información contenida en las páginas web de terceros a las que se pueda acceder por enlaces o buscadores
            desde la página web romeuycia.com.
          </p>
          <h4>3. Utilización ilícita</h4>
          <p>
            El usuario de esta página web y de sus servicios se obliga a realizar un uso conforme con las leyes y los usos del
            tráfico y se abstendrá de utilizar la web y sus servicios con fines o efectos ilícitos o que sean lesivos de los
            derechos e intereses de terceros o que de cualquier forma puedan dañar, inutilizar sobrecargar o deteriorar la web
            y los servicios o impedir la normal utilización de la web y de los servicios por parte de los usuarios. Quienes
            incumplan esta obligación responderán frente a ROMEU Y CIA. S.A. y frente a terceros de cualesquiera daños y perjuicios
            que puedan causarse a consecuencia del incumplimiento de dicha obligación.
          </p>

          <h4>4. Garantía de errores</h4>
          <p>
            ROMEU Y CIA. S.A. no garantiza la inexistencia de errores en el acceso a la web, o en su contenido; en el caso que se
            citen o reproduzcan publicaciones de carácter oficial, dicha reproducción tendrá carácter meramente informativo
            debiendo considerarse a todos los efectos como válida la publicación en su boletín o fuente oficial correspondiente.
          </p>
          <h4>5. Intercambio o difusión de información</h4>
          <p>
            ROMEU Y CIA. S.A., declina toda responsabilidad que se derive del intercambio de información entre usuarios a través
            de su página web.
          </p>
          <h4>6. Actualización y modificación de la página web</h4>
          <p>
            ROMEU Y CIA. S.A. se reserva el derecho a actualizar, modificar o eliminar la información contenida en su web site,
            y la configuración o presentación del mismo, en cualquier momento, sin previo aviso, y sin asumir responsabilidad
            alguna por ello.
          </p>
          <h4>7. Indicaciones sobre aspectos técnicos</h4>
          <p>
            ROMEU Y CIA. S.A. no asume ninguna responsabilidad que se pueda derivar de problemas técnicos o fallos en los equipos
            informáticos, no imputables a nuestra Sociedad, que se produzcan durante la conexión a la red de Internet, así como
            de daños que pudieran ser causados por terceras personas mediante intromisiones ilegítimas fuera del control de
            ROMEU Y CIA. S.A. También quedamos exonerados de toda responsabilidad ante posibles daños o perjuicios que pueda
            sufrir el usuario a consecuencia de errores, defectos u omisiones en la información que facilitemos cuando proceda
            de fuentes ajenas a nosotros.
          </p>
          <h4>8. Legislación y jurisdicción aplicables</h4>
          <p>
            Con carácter general, las relaciones con nuestros clientes, que se deriven de la prestación de los servicios
            contenidos en nuestra web, están sometidas a la legislación y la jurisdicción española. Cualquier disputa que
            pueda surgir en la interpretación de estas condiciones se resolverá en los tribunales del lugar donde tenga su
            domicilio social ROMEU Y CIA. S.A. Los usuarios de nuestra web son conscientes de todo lo expuesto y lo aceptan
            voluntariamente.
          </p>
        `,
      },
      conditions: {
        title: "Condiciones de servicio",
        content: `
          <h3>Datos fiscales del comercio</h3>
          <p>
            <div>Nombre fiscal de la sociedad: ROMEU Y CIA. S.A.</div>
            <div>CIF de la sociedad: A-28402006</div>
            <div>Domicilio de la sociedad: C/ Jorge Juan, 6, 03002, Alicante</div>
            <div>Teléfono: +34 93 292 21 25.Fax: +34 93 415 07 07</div>
            <div>Correo electrónico: barcelona@romeuycia.com</div>
            <div>Datos legales y/o registrales de la sociedad: Inscrita en el Registro Mercantil de Madrid,
              Tomo 3,757, Folio 19, Hoja 28,718. Inscripción 1.ª</div>
          </p>
          <h3>Política de venta, devolución y cancelación de reserva</h3>
          <p>Romeu y Cía, a través de su sitio web romeuferries.com realizar venta de reservas de billetes para
            transporte marítimo.</p>
          <p>
            Dichas reservas no garantizan la disponibilidad del billete solicitado. En caso de no haber disponibilidad
            en las fechas solicitadas, se devolverá a los usuarios el importe íntegro abonado y se le informará por
            correo electrónico para que pueda volver a hacer otra reserva.
          </p>
          <p>
            La anulación o cambio de fechas por parte del pasajero de la reserva del billete, incurrirá en una penalización
            del 20% del importe del mismo si la anulación se realiza antes de las 72 horas precedentes a la salida del buque.
          </p>
          <p>
            Si la  anulación de los billetes se realiza dentro de las 72 horas antes de salida del buque existirá una
            penalización por el total del importe del billete. 
          </p>
          <p>
            Para el reembolso de un billete emitido Romeu y Cía. (o Romeu Ferries), el interesado deberá dirigirse a
            cualquiera de las oficinas de la compañía. El reembolso se efectuará en función de la forma de pago del billete,
            en ningún caso serán reembolsables los gastos de emisión.
          </p>
          <h3>Política de entrega de billetes </h3>
          <p>
            Todas aquellas reservas realizadas a través de este sitio web y que hayan sido aceptadas pasarán a tramitar el
            correspondiente billete. 
          </p>
          <p>
            En un máximo de 24 horas hábiles los usuarios recibirán el billete correspondiente a la reserva solicitada a través
            de correo electrónico.
          </p>
          <p>
            Será obligatorio para todos los usuarios presentar el o los billetes en las ventanillas de la terminal en la fecha
            correspondiente para obtener las tarjetas de embarque con las que poder subir a bordo del buque. 
          </p>
        `
      },
      privacy: {
        title: "Política de Privacidad",
        content: `
          <p>
            En cumplimiento de lo establecido en la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de
            Carácter Personal, ROMEU Y CIA. S.A., informa a sus clientes de que cuantos datos personales le faciliten
            serán incluidos en un fichero automatizado de datos de carácter personal, creado y mantenido bajo la responsabilidad
            de ROMEU Y CIA. SA. La finalidad de dicho fichero es enviar ofertas comerciales en el futuro sobre productos y
            servicios que puedan resultar de interés a nuestros clientes. ROMEU Y CIA. S.A., garantiza la seguridad y
            confidencialidad de los datos facilitados. De este modo, se compromete al cumplimiento de su obligación de secreto
            de los datos de carácter personal y de su deber de guardarlos y adoptar todas las medidas necesarias para evitar
            su alteración, pérdida, tratamiento o uso no autorizado. Por lo tanto, toda la información sobre nuestros clientes
            no será utilizada con propósitos comerciales ni será cedida a terceros. Los clientes de ROMEU Y CIA. S.A. podrán en
            todo momento ejercitar los derechos de acceso, rectificación, cancelación y oposición, comunicándose por escrito a
            nuestra dirección de correo electrónico: pasajes@romeuycia.com
          </p>
        `,
      },
      cookies: {
        title: "Política de Cookies",
        content: `
          <h3>Definición y función de las cookies</h3>
          <p>
            Una cookie es un fichero que se descarga en su ordenador (el del usuario), tras acceder a determinadas
            páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información
            sobre los hábitos o preferencias de navegación de un usuario o de su equipo, con el fin de mejorar el
            funcionamiento de los sitios web y para proporcionar información analítica, comercial y de marketing.
          </p>
          <h3>Cookies utilizadas en nuestro sitio web</h3>
          <p>
            En el presente sitio web romeuferries.com de Romeu y Cía. S.A.existen las siguientes cookies:
          </p>
          <h4>1. Cookies propias</h4>
          <p>
            No existen cookies propias implementadas
          </p>
          <h4>2. Cookies de terceros</h4>
          <p>
            A continuación se detallan las cookies de terceros utilizadas en el sitio web romeuferries.com.
          </p>
          <table>
            <tr>
              <th>Tipo</th>
              <th>Nombre</th>
              <th>Duración</th>
              <th>Finalidad</th>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utma</td>
              <td>Caduca a los 2 años</td>
              <td>
                Cookie establecida por Google Analytics para registrar la fecha de la primera y última visita de un usuario.
                Al mismo tiempo, se utiliza para hacer recuento de cuantas veces visita la web un único usuario.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmb</td>
              <td>Caduca a los 30 minutos desde el último registro de página vista</td>
              <td>
                Cookie establecida por Google Analytics para registrar la hora de llegada a la web con el objetivo de
                calcular el tiempo que permanece en ella.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmc</td>
              <td>Caduca al terminar la sesión</td>
              <td>
                Cookie establecida por Google Analytics para registrar la hora de llegada a la web con el objetivo de
                calcular el tiempo que permanece en ella.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmz</td>
              <td>Caduca a los 6 meses</td>
              <td>
                Cookie establecida por Google Analytics para identificar el camino que ha seguido el usuario para acceder
                a la web, ya sea a través de acceso directo, desde un link de otra web, enlace de correo electrónico...
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_ga</td>
              <td>Caduca a los 2 años</td>
              <td>
                Cookie de Google Analytics que habilita la función de control de visitas únicas. La primera vez que un
                usuario entre en el sitio web a través de un navegador se instalará esta cookie. Cuando este usuario vuelva
                a entrar en la web con el mismo navegador, la cookie considerará que es el mismo usuario. Solo en el caso
                de que el usuario cambie de navegador, se considerará otro usuario.
              </td>
            </tr>
          </table>
          <h3>Cómo desactivar las cookies</h3>
          <p>
            Para cumplir con la legislación vigente, tenemos que pedir su permiso para gestionar cookies. Si decide no autorizar
            el tratamiento indicándonos su no conformidad, sólo usaríamos las cookies que son imprescindibles para la navegación
            por nuestra web. En este caso, no almacenaríamos ninguna cookie. En el caso de que siga navegando por nuestro
            sitio web sin denegar su autorización implica que acepta el uso de las cookies.
          </p>
          <p>
            Tenga en cuenta que si rechaza o borra las cookies de navegación, no podremos mantener sus preferencias, algunas
            características de las páginas no estarán operativas, no podremos ofrecerle servicios personalizados y cada vez
            que vaya a navegar por nuestra web tendremos que solicitarle de nuevo su autorización para el uso de cookies.
          </p>
          <p>
            Puede modificar, antes de dar su consentimiento (seguir navegando por nuestra web),  la configuración de acceso
            a la página web para evitar el uso de cookies en su equipo en cualquier momento, así como revocar el consentimiento
            ya prestado para el uso de las mismas en su navegador, desactivando o eliminando las cookies ya instaladas mediante
            la modificación de los parámetros de configuración de su navegador.
          </p>
        `,
      }
    }
  },

  sectionContact: {
    customerServicePhone: "Teléfono de atención al cliente",
    customerServiceSchedule: "De lunes a viernes de 9:00 a 14:00 y 16:00 a 19:00.",
    title: "Formulario de contacto",

    form: {
      submit: "Enviar",
      optional: "Opcional",
      fields: {
        name: "Nombre",
        surname: "Primer apellido",
        secondSurname: "Segundo apellido",
        email: "Email",
        repeatEmail: "Repetir email",
        prefix: "Prefijo",
        phone: "Teléfono móvil",
        queryType: "Tipo de consulta",
        queryMessage: "Escriba aquí la consulta",
        privacyCheck: "He leído y acepto la política de privacidad"
      },
      queryTypes: {
        0: "Consulta",
        1: "Sugerencia",
        2: "Queja",
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/index.js